import { defineMessages } from "react-intl";

export const messages = defineMessages({
  menuWelcome: {
    id: "intro-page.menu.welcome",
  },
  menuChapters: {
    id: "intro-page.menu.chapters",
  },
  menuPracticalContent: {
    id: "intro-page.menu.practical-content",
  },
  subsectionLessonTitle: {
    id: "intro-page.menu.subsection-lesson.title",
  },
  subsectionCaseStudiesTitle: {
    id: "intro-page.menu.subsection-case-studies.title",
  },
  subsectionGuidesTitle: {
    id: "intro-page.menu.subsection-guides.title",
  },
  welcomeDescription: {
    id: "intro-page.welcome.description",
  },
  welcomeTitle: {
    id: "intro-page.welcome.title",
  },
  welcomeButtonTitle: {
    id: "intro-page.welcome.button.title",
  },
  chapter1Title: {
    id: "intro-page.chapter1.title",
  },
  chapter2Title: {
    id: "intro-page.chapter2.title",
  },
  chapter3Title: {
    id: "intro-page.chapter3.title",
  },
  chapter4Title: {
    id: "intro-page.chapter4.title",
  },
  chapter5Title: {
    id: "intro-page.chapter5.title",
  },
  chapter6Title: {
    id: "intro-page.chapter6.title",
  },
  chapter7Title: {
    id: "intro-page.chapter7.title",
  },
  chapter1Description: {
    id: "intro-page.chapter1.description",
  },
  chapter2Description: {
    id: "intro-page.chapter2.description",
  },
  chapter3Description: {
    id: "intro-page.chapter3.description",
  },
  chapter4Description: {
    id: "intro-page.chapter4.description",
  },
  chapter5Description: {
    id: "intro-page.chapter5.description",
  },
  chapter6Description: {
    id: "intro-page.chapter6.description",
  },
  chapter7Description: {
    id: "intro-page.chapter7.description",
  },
  lesson1_1Title: {
    id: "intro-page.lesson1_1.title",
  },
  lesson1_2Title: {
    id: "intro-page.lesson1_2.title",
  },
  lesson1_3Title: {
    id: "intro-page.lesson1_3.title",
  },
  lesson1_4Title: {
    id: "intro-page.lesson1_4.title",
  },
  lesson1_5Title: {
    id: "intro-page.lesson1_5.title",
  },
  lesson1_6Title: {
    id: "intro-page.lesson1_6.title",
  },
  lesson1_7Title: {
    id: "intro-page.lesson1_7.title",
  },
  lesson2_1Title: {
    id: "intro-page.lesson2_1.title",
  },
  lesson2_2Title: {
    id: "intro-page.lesson2_2.title",
  },
  lesson2_3Title: {
    id: "intro-page.lesson2_3.title",
  },
  lesson2_4Title: {
    id: "intro-page.lesson2_4.title",
  },
  lesson2_5Title: {
    id: "intro-page.lesson2_5.title",
  },
  lesson2_6Title: {
    id: "intro-page.lesson2_6.title",
  },
  lesson2_7Title: {
    id: "intro-page.lesson2_7.title",
  },
  lesson3_1Title: {
    id: "intro-page.lesson3_1.title",
  },
  lesson3_2Title: {
    id: "intro-page.lesson3_2.title",
  },
  lesson3_3Title: {
    id: "intro-page.lesson3_3.title",
  },
  lesson3_4Title: {
    id: "intro-page.lesson3_4.title",
  },
  lesson3_5Title: {
    id: "intro-page.lesson3_5.title",
  },
  lesson3_6Title: {
    id: "intro-page.lesson3_6.title",
  },
  lesson3_7Title: {
    id: "intro-page.lesson3_7.title",
  },
  lesson4_1Title: {
    id: "intro-page.lesson4_1.title",
  },
  lesson4_2Title: {
    id: "intro-page.lesson4_2.title",
  },
  lesson4_3Title: {
    id: "intro-page.lesson4_3.title",
  },
  lesson4_4Title: {
    id: "intro-page.lesson4_4.title",
  },
  lesson4_5Title: {
    id: "intro-page.lesson4_5.title",
  },
  lesson4_6Title: {
    id: "intro-page.lesson4_6.title",
  },
  lesson4_7Title: {
    id: "intro-page.lesson4_7.title",
  },
  lesson5_1Title: {
    id: "intro-page.lesson5_1.title",
  },
  lesson5_2Title: {
    id: "intro-page.lesson5_2.title",
  },
  lesson5_3Title: {
    id: "intro-page.lesson5_3.title",
  },
  lesson5_4Title: {
    id: "intro-page.lesson5_4.title",
  },
  lesson5_5Title: {
    id: "intro-page.lesson5_5.title",
  },
  lesson5_6Title: {
    id: "intro-page.lesson5_6.title",
  },
  lesson5_7Title: {
    id: "intro-page.lesson5_7.title",
  },
  lesson6_1Title: {
    id: "intro-page.lesson6_1.title",
  },
  lesson6_2Title: {
    id: "intro-page.lesson6_2.title",
  },
  lesson6_3Title: {
    id: "intro-page.lesson6_3.title",
  },
  lesson6_4Title: {
    id: "intro-page.lesson6_4.title",
  },
  lesson6_5Title: {
    id: "intro-page.lesson6_5.title",
  },
  lesson6_6Title: {
    id: "intro-page.lesson6_6.title",
  },
  lesson6_7Title: {
    id: "intro-page.lesson6_7.title",
  },
  lesson7_1Title: {
    id: "intro-page.lesson7_1.title",
  },
  lesson7_2Title: {
    id: "intro-page.lesson7_2.title",
  },
  lesson7_3Title: {
    id: "intro-page.lesson7_3.title",
  },
  lesson7_4Title: {
    id: "intro-page.lesson7_4.title",
  },
  lesson7_5Title: {
    id: "intro-page.lesson7_5.title",
  },
  lesson7_6Title: {
    id: "intro-page.lesson7_6.title",
  },
  lesson7_7Title: {
    id: "intro-page.lesson7_7.title",
  },
  buttonGoToLessonSoon: {
    id: "intro-page.button.go-to-lesson-soon",
  },
  buttonGoToLesson: {
    id: "intro-page.button.go-to-lesson",
  },
  buttonGoToCaseSoon: {
    id: "intro-page.button.go-to-case-soon",
  },
  buttonGoToGuideSoon: {
    id: "intro-page.button.go-to-guide-soon",
  },
  buttonGoToCase: {
    id: "intro-page.button.go-to-case",
  },
  buttonGoToFurtherMaterials: {
    id: "intro-page.button.go-to-further-materials",
  },
  guide1Title: {
    id: "intro-page.guide1.title",
  },
  guide2Title: {
    id: "intro-page.guide2.title",
  },
  guide3Title: {
    id: "intro-page.guide3.title",
  },
  guide4Title: {
    id: "intro-page.guide4.title",
  },
  guide5Title: {
    id: "intro-page.guide5.title",
  },
  guide6Title: {
    id: "intro-page.guide6.title",
  },
  case1Title: {
    id: "intro-page.case01.navbarTitle",
  },

  case2Title: {
    id: "intro-page.case02.title",
  },
  case3Title: {
    id: "intro-page.case03.title",
  },
  case4Title: {
    id: "intro-page.case04.title",
  },
  case5Title: {
    id: "intro-page.case05.title",
  },
  case6Title: {
    id: "intro-page.case06.title",
  },
  case7Title: {
    id: "intro-page.case7.title",
  },
  case8Title: {
    id: "intro-page.case8.title",
  },
  caseStudiesDescription: {
    id: "intro-page.case-studies.description",
  },
  guidesDescription: {
    id: "intro-page.guides.description",
  },
  goToTeamButton: {
    id: "intro-page.welcome.button.team",
  },
});
